import React from "react";
import Moment from 'moment';
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { useState } from 'react';
import { Page, StyleSheet, Text, Document, Image, Font, View } from '@react-pdf/renderer'
import { Table, TableRow, TableCell, TableHeader, TH, TD } from '@ag-media/react-pdf-table';
import logo from "../invoices/logo.png"

// Font.register({
//     family: 'Oswald',
//     src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
// });


const styles = StyleSheet.create(
    {
        body: {
            fontFamily: "Helvetica",
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 35,
        },
        title: {
            fontSize: 24,
            textAlign: 'center',
            fontFamily: 'Helvetica'
        },
        from: {
            fontSize: 10,
            height:15,
            textAlign: "left",
            fontFamily: 'Helvetica'
        },
        author: {
            fontSize: 10,
            textAlign: 'center',
            marginBottom: 40,
        },
        subtitle: {
            fontSize: 18,
            margin: 12,
            fontFamily: 'Helvetica'
        },
        text: {
            margin: 12,
            marginTop: -15,
            fontSize: 10,
            textAlign: 'left',
            fontFamily: 'Helvetica',
        },
        artikeltext: {
            margin: 12,
            marginTop: -10,
            fontSize: 8.5,
            textAlign: 'left',
            fontFamily: 'Helvetica',
            marginLeft: 25
        },
        heffing: {
            margin: 12,
            marginTop: 5,
            fontSize: 10,
            textAlign: 'left',
            fontFamily: 'Helvetica',
            marginLeft: 0
        },
        image: {
            marginVertical: 15,
            marginHorizontal: 10,
            left: 0,
            top: 10,
            height: 50,
            width: 50
        },
        image_center: {
            marginVertical: 15,
            marginHorizontal: 10,
            left: 0,
            top: 10,
            height: 50,
            width: 50,
            marginLeft:240
        },
        header: {
            fontSize: 12,
            marginBottom: 20,
            textAlign: 'center',
            color: 'grey',
        },
        boxfrom: {
            left: 10,
            top: 10,
            height: 100
        },
        abox: {
            left: 10,
            top: 20,
        },
        boxto: {
            position: "absolute",
            left: 400,
            top: 125,

        },
        bold: {
            fontSize: 10,
            fontWeight: "bold"
        },
        artikel: {
            fontSize: 10,
            fontWeight: "bold",

        },
        pageNumber: {
            position: 'absolute',
            fontSize: 10,
            bottom: 30,
            left: 0,
            right: 50,
            textAlign: 'right',
            color: 'grey',
        },
        adress: {
            marginTop:50,
            textAlign: "center",
            fontSize: 9,
            bottom: 5,
            color: "darkgreen"
        },
        adress_line2: {
            textAlign: "center",
            fontSize: 9,
            bottom: 0,
             color: "darkgreen"
        },
        voorwaarden:
        {
            marginTop: 10,
              fontSize: 10,
            fontWeight: "bold",
            marginBottom:20,
            textAlign:"center"
        },
        table: {
            border: 1
        },
        container: {
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "left",
        },
        blackcontainer: {
            marginTop: 10,
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "left",
            backgroundColor:"black",
            height:30
        },
        Rowgrey: {
            marginTop: 0,
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "left",
            backgroundColor:"lightgrey",
            height:25
        },
        Rowwhite: {
            marginTop: 0,
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "left",
            backgroundColor:"transparent",
            height:25
        },
        Rowsubtotal: {
            marginTop: 0,
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "left",
            backgroundColor:"transparent",
            height:25
        },
        blackline: {
            borderWidth:0.5,
            borderColor:"black",
            marginTop: 4,
            marginBottom:4,
            backgroundColor:"black",
            height:1
        },
        Rowtotal: {
            borderWidth:1,
            borderColor:"black",
            marginTop: -4,
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "left",
            backgroundColor:"lightgrey",
            height:20
        },
        textBold: {
            margin: 6, // Handles spacing between words
            fontSize: 14,
            textAlign: "justify",
            color: "#000000",
            fontWeight: "bold",
        }, 
        tabletitle: {
            margin: 6, // Handles spacing between words
            paddingLeft:8,
            fontSize: 10,
            textAlign: "justify",
            color: "#000000",
            fontWeight: "bold",
            marginLeft: -3, // Adjust margin to align text correctly
        },
        tabletext: {
            margin: 6, // Handles spacing between words
            paddingLeft:5,
            fontSize: 10,
            textAlign: "justify",
            color: "#000000",
            fontWeight: "normal",
            marginLeft: -3, // Adjust margin to align text correctly
        },
        fullrow: {
            // borderWidth: 0,
            // borderColor: 'black',
            fontSize: 10,
            textAlign: 'left',
            fontFamily: 'Helvetica',
            marginTop:20
        },
        boldrow: {
            marginTop:10,
            width: 160,
            fontSize: 10,
            textAlign: 'right',
            fontFamily: 'Helvetica',
            fontWeight: "bold"
        },
        firstrow: {
            marginTop:10,
            width: 120,
            fontSize: 10,
            textAlign: 'left',
            fontFamily: 'Helvetica',
        },
        Header_colA: {
            marginLeft: 5,
            marginTop:10,
            width: 150,
            fontSize: 10,
            textAlign: 'left',
            fontFamily: 'Helvetica',
            color:"white"
        },
        Header_colB: {
            marginLeft: 5,
            marginTop:10,
            width: 80,
            fontSize: 10,
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color:"white"
        },
        Header_colC: {
            marginLeft: 5,
            marginTop:10,
            width: 80,
            fontSize: 10,
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color:"white"
        },
        Header_colD: {
            marginLeft: 5,
            marginTop:10,
            width: 50,
            fontSize: 10,
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color:"white"
        },
        Header_colE: {
            marginTop:10,
            width: 140,
            fontSize: 10,
            fontFamily: 'Helvetica',
            color:"white",
            textAlign:"right"
        },


        row_colA_1: {
            marginLeft: 5,
            marginTop:10,
            width: 150,
            fontSize: 10,
            textAlign: 'left',
            fontFamily: 'Helvetica',
            color:"black"
        },
        row_colB_1: {
            marginLeft: 5,
            marginTop:10,
            width: 80,
            fontSize: 10,
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color:"black"
        },
        row_colC_1: {
            marginLeft: 5,
            marginTop:10,
            width: 80,
            fontSize: 10,
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color:"black"
        },
        row_colD_1: {
            marginLeft: 5,
            marginTop:10,
            width: 50,
            fontSize: 10,
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color:"black"
        },
        row_colE_1: {
            marginTop:10,
            width: 140,
            fontSize: 10,
            fontFamily: 'Helvetica',
            color:"black",
            textAlign:"right"
        },

        row_subtotal: {
            //marginLeft: 5,
            //marginTop:10,
            width: 130,
            fontSize: 10,
           
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color:"black"
        },
        row_subtotaldesc: {
            //marginTop:10,
            width: 90,
            fontSize: 10,
            fontFamily: 'Helvetica',
            color:"black",
            textAlign:"left"
        },
        row_subtotalempty: {
            //marginTop:10,
            width: 300,
            fontSize: 10,
            fontFamily: 'Helvetica',
            color:"black",
            textAlign:"right"
        },
        row_total: {
            //marginLeft: 5,
            marginTop:5,
            width: 130,
            fontSize: 10,
            fontWeight:"bold",
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color:"black"
        },
        row_totaldesc: {
            marginTop:5,
            width: 90,
            fontSize: 10,
            fontWeight:"bold",
            fontFamily: 'Helvetica',
            color:"black",
            textAlign:"left"
        },
        middlerow: {
            marginTop:3,
            width: 120,
            fontSize: 10,
            textAlign: 'left',
            fontFamily: 'Helvetica',
        }
    });



const PDFFILE = ( {data}) => {

    //let date = "12/12/2025"
    //console.log("invoice data = " , data)
    if(data.fromdata !== undefined){
    return (
        <Document>
            <Page style={styles.body}>
                <Image
                    style={styles.image}
                    src={logo}
                />
                <div style={styles.boxfrom}>
                    <Text style={styles.from}>{data.fromdata.naam}</Text>
                    <Text style={styles.from}>{data.fromdata.straatnaam} {data.fromdata.huisnummer}/{data.fromdata.postbus}</Text>
                    <Text style={styles.from}>{data.fromdata.postcode} {data.fromdata.gemeente}</Text>
                    <Text style={styles.from}>{data.fromdata.land}</Text>
                    <Text style={styles.from}>{data.fromdata.btw_nummer}</Text>
                    <Text style={styles.from}>{data.fromdata.telefoon}</Text>
                    <Text style={styles.from}>{data.fromdata.email}</Text>
                    <Text style={styles.from}>{data.fromdata.url}</Text>
                </div>
                <div style={styles.boxto} id="tobox">
                    <Text style={styles.from}>{data.todata.Name} </Text>
                    <Text style={styles.from}>{data.todata.contactperson}</Text>
                    <Text style={styles.from}>{data.todata.straatnaam} {data.todata.huisnummer} /{data.todata.bus}</Text>
                    <Text style={styles.from}>{data.todata.zipcode} {data.todata.gemeente}</Text>
                    <Text style={styles.from}>{data.todata.land}</Text>
                    <Text style={styles.from}>{data.todata.btw_nummer}</Text>
                </div>
                <View style={styles.container}>
                    <Text style={styles.fullrow}>Betreft: {data.todata.Name}</Text>
                </View>
                <View style={styles.container}>
                    <Text style={styles.firstrow}>Nummer</Text>
                    <Text style={styles.firstrow}>Datum</Text>
                    <Text style={styles.firstrow}>Betalingstermijn</Text>
                    <Text style={styles.boldrow}>PRO-FORMA FACTUUR</Text>
                </View>
                <View style={styles.container}>
                    <Text style={styles.middlerow}>{data.hotelid}</Text>
                    <Text style={styles.middlerow}>{data.date}</Text>
                    <Text style={styles.middlerow}>10 dagen na facturatie</Text>
                    <Text style={styles.middlerow}></Text>
                </View>

                <View style={styles.blackcontainer}>
                    <Text style={styles.Header_colA}>Beschrijving</Text>
                    <Text style={styles.Header_colB}>Aantal</Text>
                    <Text style={styles.Header_colC}>Stukprijs</Text>
                    <Text style={styles.Header_colD}>Btw</Text>
                    <Text style={styles.Header_colE}>Totaal</Text>
                </View>
                {data.testarray}
                {data.invoiceTotalarray}

                <Text style={styles.heffing}>
                    Verlegging van heffing. Bij gebrek aan schriftelijke betwisting binnen een termijn van één maand na de ontvangst van de factuur, 
                    wordt de afnemer geacht te erkennen dat hij een belastingplichtige is gehouden tot de indiening van de periodieke aangiften.
                    Als die voorwaarde niet vervuld is, is de afnemer ten aanzien van die voorwaarde aansprakelijk voor de betaling van de verschuldigde belasting, interesten en geldboeten.
                </Text>
                <Text style={styles.heffing}>
                   Gebruik de volgende mededeling: {data.mededeling}
                </Text>
                <Text style={styles.heffing}>
                  Bank gegevens: {data.fromdata.banknaam} | IBAN:  {data.fromdata.iban}
                </Text>
                <Image
                    style={styles.image_center}
                    src={logo} break
                />
                <Text style={styles.voorwaarden} >
                    ALGEMENE VOORWAARDEN
                </Text>
               
                <Text style={styles.artikel}>1.</Text>
                <Text style={styles.artikeltext}>
                    De algemene voorwaarden van SHC Hotelservices BV (de Dienstverlener) zijn van toepassing en maken integraal deel uit
                    van de overeenkomst die beide partijen bindt. Bestelbonnen, offertes, algemene (factuur)voorwaarden van de Klant
                    worden uitdrukkelijk uitgesloten.
                </Text>
                <Text style={styles.artikel}>2.</Text>
                <Text style={styles.artikeltext}>
                    Tenzij uit de offerte van de Dienstverlener uitdrukkelijk en ondubbelzinnig (schriftelijk) het tegendeel blijkt, is deze geheel
                    vrijblijvend en gelden de bij de offerte behorende specificaties, kwaliteitsnormen, prijsopgaven, termijnen en andere
                    opgaven bij benadering. Deze worden enkel ter inlichting verstrekt en kunnen nooit aanleiding geven tot enig verhaal op
                    de Dienstverlener.
                </Text>
                <Text style={styles.artikel}>3.</Text>
                <Text style={styles.artikeltext}>
                    Rekening houdend met de specifieke aard van de opdracht van de Dienstverlener komen de Partijen overeen dat elke
                    klacht schriftelijk moet worden geformuleerd binnen een termijn van 24 uren vanaf de prestaties die aanleiding hebben
                    gegeven tot de klacht, op straffe van niet-ontvankelijkheid van de klacht. Geen enkele klacht schorst de verplichting tot
                    betaling.
                </Text>
                <Text style={styles.artikel}>4.</Text>
                <Text style={styles.artikeltext}>
                    De Dienstverlener is niet aansprakelijk ten aanzien van de Klant voor zware of opzettelijke fouten begaan door haar
                    werknemers, medewerkers en/of vertegenwoordigers in het kader van de uitvoering van hun professionele activiteiten.
                    De Dienstverlener is slechts aansprakelijk in geval van bedrog, fraude of opzettelijke fout. De aansprakelijkheid van de
                    Dienstverlener is in elk geval beperkt tot de rechtstreekse schade die de Klant bewijst te hebben geleden. In elk geval
                    wordt elke aansprakelijkheid van de Dienstverlener voor indirecte schade van de Klant uitdrukkelijk uitgesloten.
                    Behoudens in geval van bedrog, fraude of opzettelijke fout, is de Dienstverlener niet aansprakelijk voor of gehouden tot
                    vergoeding van immateriële, indirecte of gevolgschade, met inbegrip van (doch niet beperkt tot) winstderving,
                    omzetverlies, inkomstenderving, productiebeperkingen, administratie- of personeelskosten, een verhoging van de
                    algemene kosten, verlies van cliënteel of vorderingen van derden. De contractuele en buitencontractuele
                    aansprakelijkheid is te allen tijde beperkt tot het bedrag dat gedekt wordt door de aansprakelijkheidsverzekering die door
                    de Dienstverlener werd afgesloten.
                </Text>

                <Text style={styles.artikel}>5.</Text>
                <Text style={styles.artikeltext}>
                    In de periode van één jaar vanaf de ondertekening van de Overeenkomst, heeft de Dienstverlener het recht om op elk
                    ogenblik een deel of het geheel van de Overeenkomst op het zeggen zonder hiervoor enige rechtvaardiging te moeten
                    geven. De Dienstverlener zal hiertoe aan de Klant een aangetekende brief versturen met een opzegtermijn van drie
                    maanden, welke aanvangt vanaf de zevende (7) dag na de postdatum van de aangetekende opzeggingsbrief.
                </Text>
                <Text style={styles.artikel}>6.</Text>
                <Text style={styles.artikeltext}>
                    A) De Klant zal in geen geval personeel van de Dienstverlener of van een onderaannemer waarop de Dienstverlener beroep
                    doet voor het leveren van de Diensten, in dienst nemen, noch tijdens de uitvoering van de Overeenkomst, noch binnen een
                    termijn van één jaar vanaf de beëindiging van de Overeenkomst, tenzij de Dienstverlener schriftelijk en voorafgaandelijk
                    afstand doet van het verbod op de niet-afwerwing door de Klant.
                    de Dienstverlener werd afgesloten.
                </Text>

                <Text style={styles.artikeltext}>
                    B) Indien de Dienstverlener een inbreuk op de verbintenissen in dit artikel 6 aantoont, zal de inbreuk plegende Klant aan
                    de Dienstverlener, dan wel aan de onderaannemer waarop de Dienstverlener beroep zou doen in het kader van het leveren
                    van de Diensten, een forfaitaire schadevergoeding van 50.000 EUR per inbreuk verschuldigd zijn, alsmede een bijkomende
                    vergoeding van 500 EUR per dag dat de Klant de inbreuk niet staakt na een schriftelijke ingebrekestelling daartoe. Deze
                    forfaitaire schadevergoeding doet geen afbreuk aan het recht van de Dienstverlener of van de Onderaannemer om een
                    hogere schadevergoeding te eisen indien een hogere schade kan aangetoond worden, noch aan het recht van de
                    Dienstverlener of de Onderaannemer om in rechte naleving van de bepalingen van dit artikel te eisen op straffe van een
                    dwangsom.
                </Text>

                <Text style={styles.artikeltext}>
                    C) De Dienstverlener en de Klant erkennen dat de bepalingen van dit artikel 6 en de daaraan gekoppelde schadevergoeding
                    nodig zijn om de rechtmatige belangen van de Dienstverlener en/of onderaannemer van de Dienstverlener te vrijwaren.
                    Indien het bovenstaande niet-afwervingsbeding de wettelijke beperkingen naar tijd, ruimte en/of voorwerp zou
                    overschrijden, zal de Klant niet gerechtigd zijn om de nietigheid ervan te vorderen, maar zal het beding worden herleid tot
                    geldige proporties.
                </Text>
                <Text style={styles.artikel}>7.</Text>
                <Text style={styles.artikeltext}>
                    Bij niet-betaling van de facturen van de Dienstverlener binnen de gestelde betaaltermijn is vanaf de vervaldag van
                    rechtswege en zonder voorafgaande ingebrekestelling een verwijlintrest verschuldigd ten belope van 10 % op het
                    openstaand factuurbedrag. Eveneens is van rechtswege en zonder voorafgaande ingebrekestelling een forfaitaire
                    schadevergoeding verschuldigd ten belope van 10% van het nog verschuldigde factuurbedrag (met een minimum van 50
                    euro), onverminderd het recht van de Dienstverlener om een hogere vergoeding te vorderen mits bewijs van hogere
                    werkelijk geleden schade. Bij gebreke aan betaling op de overeengekomen datum, behoudt de Dienstverlener zicht het
                    recht voor onmiddellijk elke verdere uitvoering van de Diensten op te schorten, dan wel om de Overeenkomst als verbroken
                    te beschouwen en schadevergoeding te vorderen en onmiddellijke betaling te eisen van alle uitgereikte en nog openstaande
                    facturen. De Dienstverlener heeft het recht om zichzelf of een door haar gemandateerde derde toegang te verschaffen tot
                    de lokalen van de Klant om er haar goederen en materialen op te halen. De Klant draagt alle kosten die het terugnemen
                    van deze goederen met zicht mee brengt.
                </Text>

                <Text style={styles.adress}>
                    SHC Hotelservices BV | werfweg 10 | 3220 Holsbeek | tel 016-629252
                </Text>
                <Text style={styles.adress_line2}>
                    www.shc-hotelservices.com | info@shc-hotelservices.com
                </Text>

                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                    `${pageNumber} / ${totalPages}`
                )} fixed />
            </Page>
        </Document>

    )
    }else
    {
         return (
        <Document>
            <Page style={styles.body}>

                <div style={styles.boxfrom}>
                    <Text style={styles.from}>no data selected</Text>
                 
                </div>
            </Page>
        </Document>
         )
    }

}

export default PDFFILE;
export{
    styles
}